import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { animated, useSpring } from 'react-spring';

import ChatBot from './components/ChatBot';

import { media } from './styles/media';
import './App.css';
import { AppState } from './store/';

const ChatBotFrame = styled(animated.div)<{ show: string }>`
  margin: 2px;
  padding: 10px;
  overscroll-behavior: contain;

  ${media.phone} {
    margin: 0;
    width: 100vw;
    padding: ${props => (props.show === 'true' ? '0px' : '8px')};
  }
`;

const App: React.FC = () => {
  const chatStatus = useSelector((state: AppState) => state.chatStatus);
  const animation = useSpring({
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    }
  });

  return (
    <ChatBotFrame
      id="chatbot-frame"
      show={chatStatus.status ? 'true' : 'false'}
      style={animation}
    >
      {chatStatus.hide !== true && <ChatBot />}
    </ChatBotFrame>
  );
};
export default App;
